<template>
  <div class="control-section accordion-icons">
    <h3>HELP DOCUMENTS/FORM</h3>
    <div class="accordion-control-wrapper" v-if="!forms.isLoading">
      <ejs-accordion>
        <e-accordionitems>
          <e-accordionitem
            v-for="item in forms.category"
            v-bind:key="item.message"
            :header="getHeader(item.message)"
            :content="getContentId(item.message, item.messageId, true)"
            expanded="true"
          ></e-accordionitem>
        </e-accordionitems>
      </ejs-accordion>
      <div
        v-for="item in forms.category"
        :key="item.messageId"
        :id="getContentId(item.message, item.messageId, false)"
        style="display: none"
      >
        <li v-for="(doc, index) in item.documents" :key="index">
          <a href="#" @click="downloadDocument(doc.documentId)">{{
            getDocumentName(doc.documentName)
          }}</a>
        </li>
      </div>
      <div ref="spinnerEle" id="spinner" v-if="forms.isLoading"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { AccordionPlugin } from "@syncfusion/ej2-vue-navigations";
import { createSpinner, showSpinner } from "@syncfusion/ej2-vue-popups";
import { FETCH_GENERAL_FORMS } from "../store";
import { getDocument } from "../services/forms-api";

Vue.use(AccordionPlugin);

export default {
  name: "Forms",
  components: {},
  data() {
    return {};
  },
  async created() {
    await this.$store.dispatch(FETCH_GENERAL_FORMS);
  },
  mounted() {
    createSpinner({ target: this.$refs.spinnerEle });
    showSpinner(this.$refs.spinnerEle);
    [...document.getElementsByClassName("e-toggle-icon")].forEach((x) => x.remove());
  },
  computed: {
    ...mapGetters({
      forms: "forms",
      loggedUser: "loggedUser",
    }),
    loggedUserId() {
      return this.loggedUser?.id;
    },
  },
  methods: {
    getHeader(header) {
      return `<strong>${header}<strong>`;
    },
    getContentId(key, id, withHash) {
      return `${withHash ? "#" : ""}${key.replace(/\s/g, "")}${id.slice(-4)}`;
    },
    async downloadDocument(id) {
      // const accessToken = tokenStorage.getAccessToken();
      await getDocument(id).then((res) => {
        window.location.href = `${res.config.baseURL}${res.config.url}`;
      });
    },
    getKey(key) {
      return `${key}${Math.floor(Math.random() * 10001).toString()}`;
    },
    getDocumentName(name) {
      return name.substring(0, name.lastIndexOf("."));
    },
  },
};
</script>
